import React, { useState } from 'react';
import { CaretDownIcon, CaretRightIcon, Table } from '@exxonmobil/react-unity';
import styled from 'styled-components';
import { EndpointRows } from '../types/EndpointData';

export const EndpointRow = ({ row }: { row: EndpointRows }) => {
  const [isFolded, setIsFolded] = useState(true);
  const { columns, id } = row;

  const nonConsumerRow = columns.filter(
    (column) => !['CONSUMER', 'CONSUMPTION VOLUME (YTD)'].includes(column.columnName as string)
  );
  const consumerRow = columns.filter((column) =>
    ['CONSUMER', 'CONSUMPTION VOLUME (YTD)'].includes(column.columnName as string)
  );
  const length = consumerRow.length > 0 ? (consumerRow[0].columnValue as string[]).length : 0;

  return (
    <Table.Body.Row key={`row-${id}`}>
      {length > 1 ? (
        <StyledTableCell
          key={`row-cell-${id}`}
          dropdown
          icon={isFolded ? <CaretRightIcon size="small" /> : <CaretDownIcon size="small" />}
          onClick={() => {
            setIsFolded(!isFolded);
          }}
        />
      ) : (
        <StyledTableCell
          key={`row-cell-${id}`}
          onClick={() => {
            setIsFolded(!isFolded);
          }}
        />
      )}
      {nonConsumerRow.map((column: any) => (
        <column.columnComponent values={column.columnValue} key={column.columnName} />
      ))}
      {consumerRow.map((column: any) => {
        const showTotal = !isFolded && column.columnValue.length > 1;
        const multipleConsumer = column.columnValue.length > 1;
        return (
          <column.columnComponent
            values={isFolded ? [column.columnValue[0]] : column.columnValue}
            additionalValues={[showTotal, multipleConsumer]}
            additionalFunction={() => setIsFolded(!isFolded)}
            key={column.columnName}
          />
        );
      })}
    </Table.Body.Row>
  );
};

const StyledTableCell = styled(Table.Body.Cell)`
  & .em-c-table__cell--container {
    margin-top: 2px;
    justify-content: flex-end;
  }
`;
